export type PatientLocationData = {
  description?: string | null
  placeId?: string | null
}

export const LOCATION_OPTIONS = [
  'HOME',
  'TLC_CABIN',
  'PHARMACY',
  'FRANCE_SERVICES',
  'HEALTH_CENTER',
  'OTHER',
] as const

export type LocationOption = (typeof LOCATION_OPTIONS)[number]
